import React, { useEffect } from 'react';
import { useUser } from '../../contexts/UserContext';
import './Unauthorized.css';
import { useNavigate } from 'react-router-dom';
import { useConfig } from '../../hooks/useConfig';

const Unauthorized = () => {
  const { error } = useUser();
  const navigate = useNavigate();
  const config = useConfig();
  // Добавляем/удаляем класс для body при монтировании/размонтировании компонента
  useEffect(() => {
    // Добавляем класс к body
    document.body.classList.add('unauthorized-page-active');
    
    let isAuthenticated = localStorage.getItem('arbifox_token');
    // если человек авторизован, то перенаправляй на главную страницу
    // if (isAuthenticated) {
    //   navigate('/');
    // }
    // // Удаляем класс при размонтировании компонента
    return () => {
      document.body.classList.remove('unauthorized-page-active');
    };
  }, []);

  

  return (
    <div className="unauthorized-container">
      <div className="unauthorized-content">
        <div className="fox-logo">
          <svg width="120" height="120" viewBox="0 0 240 240" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M120 40C120 40 160 70 200 100C200 100 170 180 120 200C70 180 40 100 40 100C80 70 120 40 120 40Z" 
                  stroke="#F17742" strokeWidth="6" strokeLinecap="round" strokeLinejoin="round"/>
            <path d="M85 130C85 130 90 142 120 142C150 142 155 130 155 130" 
                  stroke="#F17742" strokeWidth="6" strokeLinecap="round" strokeLinejoin="round"/>
            <circle cx="120" cy="160" r="10" stroke="#F17742" strokeWidth="6"/>
            <path d="M80 100C80 100 90 110 80 120C70 110 80 100 80 100Z" 
                  stroke="#F17742" strokeWidth="6" strokeLinecap="round" strokeLinejoin="round"/>
            <path d="M160 100C160 100 170 110 160 120C150 110 160 100 160 100Z" 
                  stroke="#F17742" strokeWidth="6" strokeLinecap="round" strokeLinejoin="round"/>
          </svg>
        </div>
        
        <h1 className="brand-title">
          <span className="brand-light">{config.name || 'Token'}</span>
          <span className="brand-accent">BOT</span>
        </h1>
        
        <div className="slogan">
          Технологии арбитража для вашей прибыли
        </div>
        
        {error && (
          <div className="error-message">
            {error === 'Authentication required' ? 
              'Для доступа к приложению требуется аутентификация через Telegram.' :
              `Ошибка: ${error}`
            }
          </div>
        )}
        
        <div className="access-message">
          <h2>Доступ ограничен</h2>
          <p>Для использования {config.name} необходимо открыть приложение через Telegram.</p>
        </div>
        
        <div className="instruction-card">
          <h3>Как получить доступ:</h3>
          <ol>
            <li>Откройте Telegram</li>
            <li>Найдите бота <strong>{config.botName}</strong></li>
            <li>Нажмите кнопку "Старт"</li>
            <li>Выберите опцию "Открыть приложение"</li>
          </ol>
          
          <a href={`https://t.me/${config.botName}`} className="telegram-button" target="_blank" rel="noopener noreferrer">
            Открыть в Telegram
          </a>
        </div>
        
        <div className="support-text">
          Нужна помощь? Свяжитесь с нами в <a href={`${config.supportLink}`} target="_blank" rel="noopener noreferrer">Telegram</a>
        </div>
      </div>
    </div>
  );
};

export default Unauthorized; 